import React from 'react';
import styled from 'styled-components';
const FormFeedbackComponent = styled.div `
  overflow: hidden;
  height: auto;
  max-height: ${(props) => (props.showText ? '600px' : '0')};
  visibility: ${(props) => (props.showText ? 'visible' : 'hidden')};
  transition: max-height 0.25s ease-in-out;
`;
export const FormFeedback = (props) => (React.createElement(FormFeedbackComponent, { showText: props.showText, className: props.className }, props.children));
